const WAITLIST_BOUND_KEY = 'publicWaitlistModalBound';
const boundRoots = new WeakSet();

const csrfToken = (root = document) => (
  root.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || ''
);

export const setWaitlistMessage = (element, message) => {
  if (!element) return;
  element.textContent = message || '';
  element.classList.toggle('hidden', !message);
};

export const setWaitlistSubmitting = (form, submitting) => {
  const submit = form.querySelector('[data-waitlist-submit]');
  if (!submit) return;
  submit.disabled = submitting;
  submit.textContent = submitting ? 'Joining...' : 'Join waitlist';
};

export const openWaitlistModal = (trigger, root = document) => {
  const modal = root.querySelector('[data-waitlist-modal]');
  if (!modal) return;

  const planName = trigger.dataset.waitlistPlan || '';
  const source = trigger.dataset.waitlistSource || 'public_pricing';
  const planInput = modal.querySelector('[data-waitlist-plan-input]');
  const sourceInput = modal.querySelector('[data-waitlist-source-input]');
  const planLabel = modal.querySelector('[data-waitlist-plan-label]');
  const emailInput = modal.querySelector('input[type="email"]');

  if (planInput) planInput.value = planName;
  if (sourceInput) sourceInput.value = source;
  if (planLabel) planLabel.textContent = planName || 'this plan';
  setWaitlistMessage(modal.querySelector('[data-waitlist-error]'), '');
  setWaitlistMessage(modal.querySelector('[data-waitlist-success]'), '');

  modal.classList.remove('hidden');
  modal.classList.add('flex');
  window.setTimeout(() => emailInput?.focus(), 0);
};

export const closeWaitlistModal = (root = document) => {
  const modal = root.querySelector('[data-waitlist-modal]');
  if (!modal) return;

  modal.classList.add('hidden');
  modal.classList.remove('flex');
};

export const submitWaitlistForm = async (form, root = document) => {
  const error = form.querySelector('[data-waitlist-error]');
  const success = form.querySelector('[data-waitlist-success]');
  setWaitlistMessage(error, '');
  setWaitlistMessage(success, '');
  setWaitlistSubmitting(form, true);

  try {
    const response = await fetch(form.action, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'X-CSRF-Token': csrfToken(root)
      },
      body: new FormData(form)
    });
    const payload = await response.json().catch(() => ({}));

    if (!response.ok) {
      throw new Error(payload.message || 'Enter a valid email address.');
    }

    const emailField = form.querySelector('input[type="email"]');
    if (emailField) emailField.value = '';
    setWaitlistMessage(success, payload.message || "You're on the waitlist.");
  } catch (errorValue) {
    setWaitlistMessage(error, errorValue.message || 'Unable to join the waitlist.');
  } finally {
    setWaitlistSubmitting(form, false);
  }
};

export const initPublicWaitlistModal = (root = document) => {
  if (boundRoots.has(root)) return;
  if (root.documentElement?.dataset[WAITLIST_BOUND_KEY] === 'true') return;
  boundRoots.add(root);
  if (root.documentElement) root.documentElement.dataset[WAITLIST_BOUND_KEY] = 'true';

  root.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-waitlist-plan]');
    if (trigger) {
      event.preventDefault();
      openWaitlistModal(trigger, root);
      return;
    }

    if (event.target.closest('[data-waitlist-close]')) {
      event.preventDefault();
      closeWaitlistModal(root);
    }
  });

  root.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeWaitlistModal(root);
  });

  root.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-waitlist-form]');
    if (!form) return;

    event.preventDefault();
    await submitWaitlistForm(form, root);
  });
};
